import { InjectionToken } from '@angular/core';

export const APP_CONFIG = new InjectionToken('App config');
export const AUTH_TOKEN = new InjectionToken<string>('AUTH_TOKEN');
export const COMPANY_ID = new InjectionToken<string>('COMPANY_ID');
export const AUTH_METHOD = new InjectionToken<string>('AUTH_METHOD');
export const ADMIN = new InjectionToken<any>('ADMIN');

export interface IAppConfig {
  apiUrl: string;
  authUrl: string;
  hasHttps: boolean;
  webAppUrl: string;
  appUrl: string;
  recaptchaSiteKey?: string;
}
